export const getters = {
  GET_MBO_MANAGEMENT_LIST: 'GET_MBO_MANAGEMENT_LIST', //* MBO 관리 리스트 가져오기
  GET_MBO_TARGET_LIST: 'GET_MBO_TARGET_LIST', //* MBO 대상 인원 내역 리스트 가져오기
  GET_SELECTED_MBO_INFO: 'GET_SELECTED_MBO_INFO', //* MBO 관리 리스트에서 선택한 MBO 기본 정보 가져오기
  GET_MBO_EVAL_TARGET_LIST: 'GET_MBO_EVAL_TARGET_LIST', //* MBO 평가대상자 리스트 가져오기
  GET_MBO_EVAL_CONF: 'GET_MBO_EVAL_CONF', //* 단일 MBO 정보 가져오기

  GET_MBO_DROPDOWN_LIST: 'GET_MBO_DROPDOWN_LIST', //* MBO 드롭다운 리스트 가져오기
  GET_TAB_CONTENTS_MBO_TARGET: 'GET_TAB_CONTENTS_MBO_TARGET', //* MBO 대상자 탭 가져오기
  GET_TAB_CONTENTS_MBO_TARGET_SETUP: 'GET_TAB_CONTENTS_MBO_TARGET_SETUP', //* MBO 대상자 설정 탭 가져오기
  GET_VIEWS_MBO_REGIST_POPUP: 'GET_VIEWS_MBO_REGIST_POPUP', //*MBO 등록 팝업 가져오기

  GET_BTN_MBO_TARGET_SETUP: 'GET_BTN_MBO_TARGET_SETUP', //* MBO 평가대상 설정 버튼 ON/OFF 가져오기
  GET_EXIST_MBO_NAME: 'GET_EXIST_MBO_NAME', //* 등록된 MBO명 존재 유무(boolean) ON/OFF 가져오기

  GET_BE_REGIST_NAME: 'GET_BE_REGIST_NAME', //* 등록가능한 이름 ON/OFF 가져오기
  GET_ALREADY_REGIST_NAME: 'GET_ALREADY_REGIST_NAME', //* 등록불가능한 이름 ON/OFF 가져오기
  GET_IS_NEW_SAVE_MBO: 'GET_IS_NEW_SAVE_MBO', //* MBO 신규 저장 ON/OFF 가져오기
};

export const actions = {
  // TODO: FETCH CONSTANT DECLARATION
  FETCH_MBO_MANAGEMENT_LIST: 'FETCH_MBO_MANAGEMENT_LIST', //* MBO 관리 리스트 가져오기
  FETCH_MBO_TARGET_LIST: 'FETCH_MBO_TARGET_LIST', //* MBO 대상 인원 내역 리스트 가져오기
  FETCH_MBO_EVAL_TARGET_LIST: 'FETCH_MBO_EVAL_TARGET_LIST', //* MBO 평가대상자 리스트 가져오기
  FETCH_MBO_DROPDOWN_LIST: 'FETCH_MBO_DROPDOWN_LIST', //* MBO 드롭다운 리스트 가져오기
  FETCH_MBO_EVAL_CONF: 'FETCH_MBO_EVAL_CONF', //* 단일 MBO 정보 가져오기
  FETCH_EXIST_MBO_NAME: 'FETCH_EXIST_MBO_NAME', //* 등록된 MBO명 존재 유무 (booelan) 가져오기

  // TODO: INSERT CONSTANT DECLARATION
  INSERT_MBO_EVAL_TARGET_LIST: 'INSERT_MBO_EVAL_TARGET_LIST', //* MBO 평가 대상자 INSERT
  INSERT_NEW_MBO: 'INSERT_NEW_MBO', //* 단일 MBO 정보 INSERT

  // TODO: UPDATE CONSTANT DECLARATION
  UPDATE_MBO: 'UPDATE_MBO', // *단일 MBO 정보  UPDATE
  UPDATE_MBO_STATUS: 'UPDATE_MBO_STATUS', //* MBO 평가기간 오픈
  UPDATE_MBO_TARGET_LIST: 'UPDATE_MBO_TARGET_LIST', //* 사원 MBO 정보 초기화

  // TODO: DELETE CONSTANT DECLARATION
  DELETE_MBO: 'DELETE_MBO', //* MBO 삭제
  DELETE_MBO_TARGET_LIST: 'DELETE_MBO_TARGET_LIST', //* MBO 대상인원내역 삭제

  // TODO: INIT CONSTANT DECLARATION
  INIT_MBO_MANAGEMENT_LIST: 'INIT_MBO_MANAGEMENT_LIST', //* MBO 관리 리스트 초기화
  INIT_MBO_TARGET_LIST: 'INIT_MBO_TARGET_LIST', //* MBO 대상 인원 내역 리스트 초기화
  INIT_SELECTED_MBO_INFO: 'INIT_SELECTED_MBO_INFO', //* MBO 관리 리스트에서 선택한 MBO 기본 정보 초기화
  INIT_MBO_EVAL_TARGET_LIST: 'INIT_MBO_EVAL_TARGET_LIST', //* MBO 평가대상자 리스트 초기화
  INIT_MBO_EVAL_CONF: 'INIT_MBO_EVAL_CONF', //* 단일 MBO 정보 초기화

  INIT_TAB_CONTENTS_MBO_TARGET: 'INIT_TAB_CONTENTS_MBO_TARGET', //* MBO 대상자 탭 초기화
  INIT_TAB_CONTENTS_MBO_TARGET_SETUP: 'INIT_TAB_CONTENTS_MBO_TARGET_SETUP', //* MBO 대상자 설정 탭 초기화

  INIT_VIEWS_MBO_REGIST_POPUP: 'INIT_VIEWS_MBO_REGIST_POPUP', //*MBO 등록 팝업 초기화

  INIT_BTN_MBO_TARGET_SETUP: 'INIT_BTN_MBO_TARGET_SETUP', //* MBO 평가대상 설정 버튼 ON/OFF 초기화
  INIT_EXIST_MBO_NAME: 'INIT_EXIST_MBO_NAME', //* 등록된 MBO명 존재 유무 (booelan) 저장

  INIT_BE_REGIST_NAME: 'INIT_BE_REGIST_NAME', //* 등록가능한 이름 ON/OFF 초기화
  INIT_ALREADY_REGIST_NAME: 'INIT_ALREADY_REGIST_NAME', //* 등록불가능한 이름 ON/OFF 초기화
  INIT_IS_NEW_SAVE_MBO: 'INIT_IS_NEW_SAVE_MBO', //* MBO 신규 저장 ON/OFF 초기화
};

export const mutations = {
  SET_MBO_MANAGEMET_LIST: 'SET_MBO_MANAGEMET_LIST', //*MBO 관리 리스트 저장
  SET_MBO_TARGET_LIST: 'SET_MBO_TARGET_LIST', //* MBO 대상 인원 내역 리스트 저장
  SET_SELECTED_MBO_INFO: 'SET_SELECTED_MBO_INFO', //* MBO 관리 리스트에서 선택한 MBO 기본 정보 저장
  SET_MBO_EVAL_TARGET_LIST: 'SET_MBO_EVAL_TARGET_LIST', //* MBO 평가대상자 리스트 저장
  SET_MBO_EVAL_CONF: 'SET_MBO_EVAL_CONF', //*단일 MBO 정보 저장

  SET_MBO_DROPDOWN_LIST: 'SET_MBO_DROPDOWN_LIST', //* MBO 드롭다운 리스트 저장

  SET_TAB_CONTENTS_MBO_TARGET: 'SET_TAB_CONTENTS_MBO_TARGET', //* MBO 대상자 탭 저장
  SET_TAB_CONTENTS_MBO_TARGET_SETUP: 'SET_TAB_CONTENTS_MBO_TARGET_SETUP', //* MBO 대상자 설정 탭 저장

  SET_VIEWS_MBO_REGIST_POPUP: 'SET_VIEWS_MBO_REGIST_POPUP', //*MBO 등록 팝업 저장

  SET_BTN_MBO_TARGET_SETUP: 'SET_BTN_MBO_TARGET_SETUP', //* MBO 평가대상 설정 버튼 ON/OFF 저장

  SET_EXIST_MBO_NAME: 'SET_EXIST_MBO_NAME', //* 등록된 MBO명 존재 유무 (booelan) 저장

  SET_BE_REGIST_NAME: 'SET_BE_REGIST_NAME', //* 등록가능한 이름 ON/OFF 저장
  SET_ALREADY_REGIST_NAME: 'SET_ALREADY_REGIST_NAME', //* 등록불가능한 이름 ON/OFF 저장
  SET_IS_NEW_SAVE_MBO: 'SET_IS_NEW_SAVE_MBO', //* MBO 신규 저장 ON/OFF 저장
};

//* ROOT ACTIONS CONSTANT
export const rootActions = {
  ...Object.entries(actions).reduce((acc, cur) => {
    acc[cur[0]] = `mboManagement/${cur[1]}`;
    return acc;
  }, {}),
};

//* ROOT MUTATIONS CONSTANT
export const rootMutations = {
  ...Object.entries(mutations).reduce((acc, cur) => {
    acc[cur[0]] = `mboManagement/${cur[1]}`;
    return acc;
  }, {}),
};
